// frontend/src/components/parts/AddPart.js
// "+ Add Part" -- renders the shared Part details form in create mode.
import React from 'react';
import PartForm from './PartForm';

const AddPart = ({ onSuccess, onCancel }) => (
    <PartForm onSuccess={onSuccess} onCancel={onCancel} />
);

export default AddPart;
